<template><div><h1>VUX V2.6.1 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持属性 compute-days-function 用以动态设置日期 #1992 </li>
</ul>
<h2><a href="/zh-CN/components/grid.html">Grid</a></h2>
<ul><li>[feature] 添加 `cols` 属性，自定义列数</li>
</ul>
<h2><a href="/zh-CN/components/scroller.html">Scroller</a></h2>
<ul><li>[change] 在`updated` 钩子中调用`reset`</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] 为 label 设置 for 属性 #1983</li>
<li>[feature] 支持属性 mask 对输入值进行格式化</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.1-252.vue?59637893